<template>
    <v-container wrap grid-list-md class="pa-0">
        <div v-for="(question, index) in questionsObject" 
            :key="`question-${index}`">
            <v-flex xl12 >
                <v-card 
                    v-if="question.active_date && (question.target_audience == 'GENERALPUBLIC' || (question.target_audience != 'GENERALPUBLIC' && asopaf == 1))" 
                    elevation-1
                    class="my-3"
                    :class="!!question.deactive_date || !!answered[question.id] ? 'disabled' : ''"
                >
                    <v-card-title class="title pb-0">
                        <div><!--{{ index+1 }} - -->
                            {{ question.name }} 
                            <v-btn v-for="file_url in  question.attachment_url ? question.attachment_url.split(',') : null" :href="file_url" target="_blank" class="blue--text ma-0" :key="file_url" title="Ver archivo adjunto" icon>
                                <v-icon>{{ /\.(jpe?g|png|gif|bmp)$/i.test(file_url) ? 'crop_original' : 'attach_file' }}</v-icon>
                            </v-btn>
                            <span v-if="question.target_audience != 'GENERALPUBLIC'" class="d-inline" title="Pregunta para grupo cerrado"><v-icon class="orange--text">security</v-icon></span>
                        </div>
                    </v-card-title>
                    <v-card-text class="pb-0 text-md-left">
                        <span class="subheading">{{ question.description }}</span>
                        <v-radio-group v-model="answer[question.id]" v-if="question.question_type != 'YESNO'" class="mt-1 mb-1 ml-2" >
                            <v-radio
                                v-for="detail in question.question_detail"
                                :key="detail.id"
                                :label="detail.text"
                                :value="detail.id"
                                :readonly="!!answered[question.id]||!!question.deactive_date"
                                :color="!!answered[question.id] ? 'success' : 'accent'"
                            ></v-radio>
                        </v-radio-group>
                        <v-radio-group v-else v-model="answer[question.id]" class="mt-1 mb-1 ml-2" >
                            <v-radio label="Si" value="YES" :readonly="!!answered[question.id]||!!question.deactive_date" :color="!!answered[question.id] ? 'success' : 'accent'"></v-radio>
                            <v-radio label="No" value="NO" :readonly="!!answered[question.id]||!!question.deactive_date" :color="!!answered[question.id] ? 'success' : 'accent'"></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <span v-if="question.active_date && !question.deactive_date && !answered[question.id]" class="warning--text">
                            <span :key="`counter-q${index}-${counter}`">{{ showCounter(question.active_date) }}</span>
                        </span>
                        <v-hover v-if="!answered[question.id] && !question.deactive_date">
                            <v-btn 
                                @click="sendAnswer(question, answer[question.id])"
                                title="Enviar respuesta"
                                slot-scope="{ hover }"
                                :disabled="!!answered[question.id]"
                                class="mx-0 ml-1"
                                :loading="isLoading"
                                :color="`${ !answer[question.id] ? 'grey' : hover ? 'primary' : 'info' }`"
                                flat  >
                                Votar <v-icon class="ml-2">send</v-icon>
                            </v-btn>
                        </v-hover>
                        <div v-else-if="!!answered[question.id]" class="py-1 success--text text--darken-3">
                            <v-icon 
                                class="mx-0"
                                color="success"
                            >
                                check_circle_outline
                            </v-icon>
                            {{ !!answered[question.id] ? `${answered[question.id]}` : '' }}
                        </div>
                        <div v-else-if="!!question.deactive_date" class="pink--text text--darken-2">
                            <v-icon>snooze</v-icon> Tiempo finalizado
                        </div>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    name: 'QuestionsComponent',
    props: {
        questionsObject: {
            type: Array,
            required: true
        },
        answersObject: {
            type: Array,
            required: true
        },
        asopaf: {
            type: Number,
            default: 0,
        },
        currentTime: {
            type: Date,
            default: new Date()
        }
    },
    created(){
        this.checkAnswers(this.answersObject)
        this.countDown();
    },
    data: () => ({
        isLoading: false,
        answer: [],
        answered: [],
        counter: 0,
    }),
    methods: {
        countDown(){
            const self = this;          
            this.intervalid1 = setInterval(function(){
                self.counter += 1
            }, 1000);
        },
        sendAnswer(question, answer) {
            let context = this
            if (!answer){
                 context.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Debe seleccionar una respuesta, verifique'
                })
                return
            }
            context.isLoading = true
            const current_time = context.currentTime.toISOString().substring(0,16).replace("T"," ")
            let payload = {'assembly_id': question.assembly_id, 'assemblyquestion_id': question.id, 'assemblyquestiondetail_id': null, 'value': null  }
            if (question.question_type == 'YESNO'){
                payload['value'] = answer
            } else if(question.question_type == 'SINGLECHOICE'){
                payload['assemblyquestiondetail_id'] = answer
            }
            
            axios.post(`/api/assemblyquestionsanswers/answer`, payload )
                .then(res => {
                const { data } = res          
                    context.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: 'Respuesta enviada'
                    })
                    context. $nextTick (() => {
                        context.answer[question.id] = answer;
                        context.answered[question.id] = current_time;
                        context.$forceUpdate();
                    })
                    this.$emit('getAssemblyPlease', false)
                })
                .catch(err => {
                    context.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Ha ocurrido un error, o el tiempo para responder esta pregunta ha terminado'
                    })
                    this.$emit('getAssemblyPlease', false)
                    console.error(err);
                })
                .finally(function(){ 
                    context.isLoading = false
                })
        },

        checkAnswers(answers){
            this.questionsObject.forEach(question => {
                answers.forEach(answerObj => {
                    if (!!answerObj.updated_at){
                        this.answer[answerObj.assemblyquestion_id] = null;
                        this.answered[answerObj.assemblyquestion_id] = null;
                        this.answer[answerObj.assemblyquestion_id] = answerObj.assemblyquestiondetail_id ? answerObj.assemblyquestiondetail_id : answerObj.value;
                        this.answered[answerObj.assemblyquestion_id] = answerObj.updated_at.substring(0,16)
                    }
                });
            })
            
        }, 
        
        showCounter(time, play){
            let current = new Date()
            if (this.currentTime > current){
                current = this.currentTime
            }
            let elapsed = (current.getTime() - moment(time).valueOf()) / 1000
            if (elapsed >= 0) {
                const diff = {};
                diff.days    = Math.floor(elapsed / 86400);
                diff.hours   = Math.floor(elapsed / 3600 % 24);
                diff.minutes = Math.floor(elapsed / 60 % 60);
                diff.seconds = Math.floor(elapsed % 60);
                let message = `Activo hace ${diff.hours}h ${diff.minutes}m ${diff.seconds}s (${time.substring(11,16)})`.replace(" 0s", "").replace(" 0m","").replace(" 0h","")
                return message
            } else {
                return '';
            }
        }
    },
    watch: {
        answersObject: {
            handler: function(newVal, oldVal) {
                this.checkAnswers(newVal)
            },
            deep: true
        }
    }
}
</script>
<style>
    .v-card.theme--light.v-sheet.disabled {
        background-color: #ededed !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/questions-component.vue